import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EnrolmentRoutingModule } from './enrolment-routing.module';
import { EnrolmentListComponent } from './enrolment-list/enrolment-list.component';
import { AddEnrolmentComponent } from './add-enrolment/add-enrolment.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { ArchwizardModule } from 'angular-archwizard';
import { EditEnrolmentComponent } from './edit-enrolment/edit-enrolment.component';
import { NgxMaskModule } from 'ngx-mask';
import { NgxSpinnerModule } from 'ngx-spinner';
import { EnrolmentViewComponent } from './enrolment-view/enrolment-view.component';
import {MatMenuModule} from '@angular/material/menu';
import { NewManageComponent } from './new-manage/new-manage.component';
import { EnrolledStudentFeesComponent } from './enrolled-student-fees/enrolled-student-fees.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';


@NgModule({
  declarations: [
    EnrolmentListComponent,
    AddEnrolmentComponent,
    EditEnrolmentComponent, 
    EnrolmentViewComponent,
    NewManageComponent,
    EnrolledStudentFeesComponent
  ],
  imports: [
    CommonModule,
    EnrolmentRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgxDatatableModule,
    PipeModule,
    NgbModule,
    NgSelectModule,
    ArchwizardModule,
    NgxSpinnerModule,
    NgxMaskModule.forRoot(),
    MatMenuModule,
    MatSlideToggleModule
  ],
})
export class EnrolmentModule { }
